import { Box } from "@dropbox/dig-foundations";
import { useMirageAnalyticsContext } from "@mirage/analytics/AnalyticsProvider";
import { PAP_View_DashSelfServeOnboarding } from "@mirage/analytics/events/types/view_dash_self_serve_onboarding";
import { useDoOnceOnMount } from "@mirage/shared/hooks/useDoOnceOnMount";
import { ExtensionUpsell } from "../extension-upsell/ExtensionUpsell";

type Props = {
  isAdmin: boolean;
  onContinue: () => void;
};

export const OnboardingDownloadExtensionStep = ({
  isAdmin,
  onContinue,
}: Props) => {
  const { reportPapEvent } = useMirageAnalyticsContext();

  useDoOnceOnMount(() => {
    reportPapEvent(
      PAP_View_DashSelfServeOnboarding({
        selfServeIsTeamAdmin: isAdmin,
        onboardingStep: "extension_download",
        featureLine: "onboarding",
      }),
    );
  });

  return (
    <Box display={"flex"} flexDirection={"column"} alignItems={"center"}>
      <ExtensionUpsell
        loggingSurface="self_serve_onboarding"
        onExtensionUpsellButtonClick={onContinue}
      />
    </Box>
  );
};
